import { Language } from '@funnellab/shared/src/types/directus-enums.ts';
import { SearchParamKeys } from '@funnellab/shared/src/types/SearchParamKeys.ts';

export enum Paths {
  ROOT = '/',
  PROFILE = '/profile',
  LOGIN = '/login',
  LOGOUT = '/logout',
  REGISTER = '/register',
  VERIFY_MAIL = '/verifyEmail',
  START_PASSWORD_RESET = '/reset-password/start',
  RESET = '/reset-password',
  JOBS = '/jobs',
  JOB_WIZARD = '/jobs/:jobId/wizard',
  JOB_DETAILS = '/jobs/:jobId',
  JOB_CREATIVE_BUILDER = '/jobs/:jobId/creativeBuilder',
  CHATBOT_BUILDER = '/jobs/:jobId/chatbotBuilder',
  ORGANIZATIONS = '/organizations',
  ORGANIZATION_DETAILS = '/organizations/:organizationId',
  SUPPORT = '/support',
  COACHING = '/coaching',
  CHATBOT = '/chatbot/:jobId',
}

export const EXTERNAL_LINKS = {
  IMPRINT: {
    [Language.EN_US]: 'https://www.funnellab.com/imprint',
    [Language.DE]: 'https://www.funnellab.com/de/impressum',
  },
  PRIVACY_POLICY: {
    [Language.EN_US]: 'https://www.funnellab.com/privacy-policy',
    [Language.DE]: 'https://www.funnellab.com/de/datenschutz',
  },
  TERMS_AND_CONDITIONS: {
    [Language.EN_US]: 'https://www.funnellab.com/terms-and-conditions',
    [Language.DE]: 'https://www.funnellab.com/de/agb',
  },
  FAQ: {
    [Language.EN_US]: 'https://www.funnellab.com/en#faq',
    [Language.DE]: 'https://www.funnellab.com/de#faq',
  },
  YOUTUBE: 'https://www.youtube.com/@funnellabrecruiting',
  INSTAGRAM: 'https://www.instagram.com/funnellabrecruiting/',
  LINKED_IN: 'https://de.linkedin.com/company/funnellabrecruiting',
};

export enum SearchParamValues {
  SHOW_SUCCESS_TRUE = `${SearchParamKeys.SHOW_SUCCESS}=true`,
  LOGIN_INFO_REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS',
}

export function generateJobWizardUrl(jobId: string) {
  return `${Paths.JOB_WIZARD}`.replace(':jobId', jobId);
}

export function generateJobWizardUrlFromFirstStep(jobId: string) {
  return `${Paths.JOB_WIZARD}`.replace(':jobId', jobId) + '?step=1';
}

export const NEW_JOB_ID = 'new';

export function getNewJobWizardUrl() {
  return Paths.JOB_WIZARD.replace(':jobId', NEW_JOB_ID);
}

export function getJobDetailsUrl(jobId: string) {
  return Paths.JOB_DETAILS.replace(':jobId', jobId);
}

export function buildSearchString(params: SearchParamValues[]): string {
  return `?${params.join('&')}`;
}

export function getOrganizationDetailsUrl(organizationId: string) {
  return Paths.ORGANIZATION_DETAILS.replace(':organizationId', organizationId);
}

export function getNewJobWizardUrlWithOrganization(organizationId: string) {
  return `${getNewJobWizardUrl()}?${SearchParamKeys.ORG_ID}=${organizationId}`;
}
